import { Box, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export default function UpToDateStep({ version, onDone }) {
  return (
    <Box sx={{ textAlign: 'center', py: 5 }}>
      <CheckCircleIcon sx={{ fontSize: 56, color: 'success.main', mb: 2 }} />
      <Typography variant="h6" gutterBottom>Your sensor is up to date</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        You&apos;re on the latest version{version ? ` (${version})` : ''}.
      </Typography>
      <Button variant="contained" onClick={onDone}>Done</Button>
    </Box>
  );
}
